import React, { useEffect, useState } from "react";
import DataTableBase from "../../../Components/Common/DataTableBase/DataTableBase";
import { t } from "i18next";
import { Button } from "reactstrap";
import { useConfirmDialogStore } from "../../../stores/Modal/ConfirmDialogStore";
import { useSplashStore } from "../../../stores/Assets/splash";
import AddSplash from "./Components/AddSplash";
import EditSplash from "./Components/EditSplash";
import { Permission } from "../../../Layouts/Permissions";
import { canEdit } from "../../../helpers/permissions";
import SearchBar from "../../../Components/Common/SearchBar";

const Splash = () => {
  const [totalRows, setTotalRows] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const { getSplashes, isLoading, splashes, deleteSplash, pagination } =
    useSplashStore((state) => state);
  const { showConfirm } = useConfirmDialogStore((state) => state);
  const [showAddSplashModal, setShowAddSplashModal] = useState(false);
  const [showEditSplashModal, setShowEditSplashModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [canEditSplash, setCanEditSplash] = useState(false);

  useEffect(() => {
    const checkPermission = async () => {
      const res = await canEdit("setting");
      setCanEditSplash(res);
    };
    checkPermission();
  }, []);

  useEffect(() => {
    getSplashes({ page: 1, perPage: 10, search: searchTerm });
  }, [searchTerm]);

  useEffect(() => {
    setTotalRows(pagination?.totalItems || 0);
  }, [pagination]);

  const toggleAddSplashModal = () => {
    setShowAddSplashModal(!showAddSplashModal);
  };

  const toggleEditSplashModal = (row) => {
    setSelectedRow(row);
    setShowEditSplashModal(!showEditSplashModal);
  };

  const deleteSplashFun = async (id) => {
    try {
      await deleteSplash(id);
    } catch (e) {
      console.log(e);
    }
  };

  const onChangePage = (page) => {
    getSplashes({ page: page, perPage: 10, search: searchTerm });
  };

  const searchHandler = (searchText) => {
    setSearchTerm(searchText);
  };

  const columns = [
    {
      name: t("ID"),
      selector: (row) => row?.splash_id,
      width: "70px",
      sortable: true,
      wrap: true,
    },
    {
      name: t("Title"),
      selector: (row) => row?.title,
      sortable: true,
      wrap: true,
    },
    {
      name: t("Title (AR)"),
      selector: (row) => row?.title_ar,
      sortable: true,
      wrap: true,
    },
    {
      name: t("Subtitle"),
      selector: (row) => row?.subtitle,
      sortable: true,
      wrap: true,
    },
    {
      name: t("Subtitle (AR)"),
      selector: (row) => row?.subtitle_ar,
      sortable: true,
      wrap: true,
    },
    {
      name: t("Linked Spaces"),
      selector: (row) => row?.spaces,
      sortable: false,
      width: '180px',
      wrap: true,
      cell: (row) => (
        <div className="d-flex flex-wrap gap-2">
          {row?.spaces && row.spaces.length > 0 ? (
            <div >
              {row.spaces.map((space, idx) => (
                <span key={space.space_id || idx} style={{ backgroundColor: '#c59253', width: 'fit-content', color: '#fff' }} className="badge me-1 mb-1">
                  {space.name || `ID: ${space.space_id}`}
                </span>
              ))}
            </div>
          ) : (
            <span className="text-muted">-</span>
          )}
        </div>
      ),
    },
    {
      name: t("Menu Item"),
      selector: (row) => row?.menu_item_id,
      sortable: true,
      wrap: true,
      cell: (row) => (
        <div>
          {row?.service_action_type === "CALL_WAITER" ? (
            <span className="badge bg-soft-info text-info">{t("Call Waiter")}</span>
          ) : row?.menu_item_id ? (
            <span>
              {row?.menu_item?.name || row?.menu_item?.name_ar || `ID: ${row.menu_item_id}`}
            </span>
          ) : (
            <span className="text-muted">-</span>
          )}
        </div>
      ),
    },
    {
      name: t("Menu URL"),
      selector: (row) => row?.menu_url,
      sortable: true,
      wrap: true,
    },
    {
      name: t("Active"),
      selector: (row) => row?.is_active,
      sortable: true,
      wrap: true,
      cell: (row) => (
        <div>
          <span
            className={`badge ${row?.is_active ? "bg-success" : "bg-danger"}`}
          >
            {row?.is_active ? t("Yes") : t("No")}
          </span>
        </div>
      ),
    },
    {
      name: t("Created At"),
      selector: (row) => row?.created_at,
      sortable: true,
      wrap: true,
      cell: (row) => (
        <div>
          {row?.created_at
            ? new Date(row.created_at).toLocaleDateString()
            : "-"}
        </div>
      ),
    },
  ];

  return (
    <>
      <DataTableBase
        tableTitle={"SPLASHES"}
        customHeader={
          <div className="d-flex flex-column flex-md-row align-items-stretch justify-content-between gap-2 w-100 mb-2">
            {canEditSplash ? (
              <Permission level={2} feature="setting">
                <Button
                  color="success"
                  onClick={toggleAddSplashModal}
                  className="d-flex align-items-center justify-content-center w-100"
                  style={{
                    flex: "0 0 10%",
                    padding: "0.4rem 2rem",
                    whiteSpace: "nowrap",
                    fontSize: "13px",
                  }}
                >
                  + {t("Add Splash")}
                </Button>
              </Permission>
            ) : null}
            <div
              className="d-flex flex-column flex-md-row align-items-stretch gap-2 w-100 px-2"
              style={{ flex: "0 0 60%" }}
            >
              <div className="d-flex align-items-center gap-2 w-100">
                <h6 className="text-nowrap mb-0">Search: </h6>
                <div className="flex-grow-1">
                  <SearchBar
                    onSearch={searchHandler}
                    placeholder="Search splashes..."
                  />
                </div>
              </div>
            </div>
          </div>
        }
        data={splashes}
        columns={columns}
        loading={isLoading}
        paginationTotalRows={totalRows}
        onChangePage={onChangePage}
        onHeaderAddBtnClick={null}
        onSearchIconClick={() => { }}
        actionColWidth="100px"
        showSearch={false}
        showActionColumn={canEditSplash}
        showSubHeader={false}
        showActionButtons={false}
        customActionBtns={(row) => (
          <>
            <div className="flex gap-2">
              <Permission level={2} feature="setting">
                <button
                  className="btn btn-sm btn-warning"
                  onClick={() => toggleEditSplashModal(row)}
                  title="Edit"
                >
                  <i className="ri-edit-fill"></i>
                </button>
              </Permission>
              <Permission level={2} feature="setting">
                <button
                  className="btn btn-sm btn-danger"
                  onClick={() => {
                    showConfirm(
                      () => deleteSplashFun(row?.splash_id),
                      () => { },
                      t("Confirm Delete"),
                      t(
                        `Are you sure you want to delete Splash ${row?.title || row?.splash_id}?`
                      )
                    );
                  }}
                  title="Delete"
                >
                  <i className="ri-delete-bin-line"></i>
                </button>
              </Permission>
            </div>
          </>
        )}
      />

      {showAddSplashModal && (
        <AddSplash
          toggleAddSplashModal={toggleAddSplashModal}
          showAddSplashModal={showAddSplashModal}
        />
      )}
      {selectedRow && (
        <EditSplash
          rowData={selectedRow}
          toggleEditSplashModal={toggleEditSplashModal}
          showEditSplashModal={showEditSplashModal}
        />
      )}
    </>
  );
};

export default Splash;

